import React from 'react'
import Topheader from '../../components/Topheader'
import style from './styles.module.css'
export default function Rewardpoints() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Pontos de Recompensa" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    P. O que são Pontos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    Os Pontos de Recompensa são a moeda no jogo que você ganha jogando, vencendo torneios e alcançando posições altas nas tabelas de líderes. Você pode resgatá-los na Baazi Store por ofertas exclusivas e cartões-presente.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    P. O que posso comprar com os Pontos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    Os Pontos de Recompensa podem ser resgatados na Baazi Store para obter as incríveis recompensas disponíveis atualmente. Novas recompensas são adicionadas regularmente, continue verificando.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. Preciso gastar dinheiro para obter Pontos de Recompensa?</div>
                <div className={style.sub_text3}>Não. Apenas use suas Fichas Gratuitas com inteligência. Jogue, compita e ganhe pontos. Nenhum pagamento é necessário.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. Os Pontos de Recompensa têm prazo de validade?</div>
                <div className={style.sub_text3}>Não imediatamente, mas os pontos não utilizados podem ser redefinidos durante os ciclos de atualização da temporada. Mantenha-se ativo para continuar subindo e resgatando.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. Existe um limite mensal de resgates?</div>
                <div className={style.sub_text3}>Sim, você pode realizar no máximo 30 resgates por mês usando seus Pontos de Recompensa.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. Os Pontos de Recompensa podem ser convertidos em dinheiro?</div>
                <div className={style.sub_text3}>Não. Os Pontos de Recompensa só podem ser usados para resgatar recompensas na Baazi Store.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. Meus Pontos de Recompensa não foram creditados. O que faço?</div>
                <div className={style.sub_text3}>
                    Atualize o app ou saia e faça login novamente. Se o problema persistir, entre em contato conosco em <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> com seu nome de usuário e os detalhes do jogo.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. Resgatei meus Pontos de Recompensa mas não recebi o item.</div>
                <div className={style.sub_text3}>
                    Por favor, aguarde até 48 horas para o processamento. Se ainda não receber, entre em contato conosco em <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> com o nome da recompensa escolhida e a data do resgate para obter ajuda.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text3}>Para perguntas mais detalhadas, visite a seção de Pontos de Recompensa dentro do app.</div>

            </div>
        </div>
    )
}
